import { ReactNode } from 'react';
import { Badge, BadgeProps } from 'shared/badge_icon/Badge';
import styled from 'styled-components';

const Container = styled.div`
    display: inline-block;
    position: relative;
`;

const BadgeContainer = styled.div`
    position: absolute;
    top: 45%;
    right: 45%;
    width: 1px;
    height: 1px;
`;

const PositionedBadge = styled(Badge)`
    position: absolute;
    bottom: 0;
    left: 0;
`;

export type BadgeConfig = Omit<BadgeProps, 'className'>;

export type BadgeIconProps = Readonly<{
    icon: ReactNode;
    badge?: BadgeConfig;
    className?: string;
}>;

export function BadgeIcon({ className, icon, badge }: BadgeIconProps) {
    return (
        <Container className={className}>
            {icon}
            {badge && (
                <BadgeContainer>
                    <PositionedBadge {...badge} />
                </BadgeContainer>
            )}
        </Container>
    );
}
